function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, inject, computed, openBlock, createElementBlock, unref, normalizeClass, normalizeStyle, createElementVNode, renderSlot, toDisplayString, createVNode, withCtx, createBlock, resolveDynamicComponent, createCommentVNode } from 'vue';
import { ElIcon } from '../../icon/index.mjs';
import '../../focus-trap/index.mjs';
import '../../../hooks/index.mjs';
import '../../../utils/index.mjs';
import { dialogInjectionKey } from './constants.mjs';
import { dialogContentProps, dialogContentEmits } from './dialog-content.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useLocale } from '../../../hooks/use-locale/index.mjs';
import { CloseComponents } from '../../../utils/vue/icon.mjs';
import { FOCUS_TRAP_INJECTION_KEY } from '../../focus-trap/src/tokens.mjs';
import { composeRefs } from '../../../utils/vue/refs.mjs';
import { useDraggable } from '../../../hooks/use-draggable/index.mjs';
const _hoisted_1 = ["aria-level"];
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["id"];
const __default__ = defineComponent({
  name: "ElDialogContent"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: dialogContentProps,
  emits: dialogContentEmits,
  setup(__props) {
    const props = __props;
    const _useLocale = useLocale(),
      t = _useLocale.t;
    const Close = CloseComponents.Close;
    const _inject = inject(dialogInjectionKey),
      dialogRef = _inject.dialogRef,
      headerRef = _inject.headerRef,
      bodyId = _inject.bodyId,
      ns = _inject.ns,
      style = _inject.style;
    const _inject2 = inject(FOCUS_TRAP_INJECTION_KEY),
      focusTrapRef = _inject2.focusTrapRef;
    const dialogKls = computed(() => [ns.b(), ns.is("fullscreen", props.fullscreen), ns.is("draggable", props.draggable), ns.is("align-center", props.alignCenter), {
      [ns.m("center")]: props.center
    }, props.customClass]);
    const composedDialogRef = composeRefs(focusTrapRef, dialogRef);
    const draggable = computed(() => props.draggable);
    useDraggable(dialogRef, headerRef, draggable);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: unref(composedDialogRef),
        class: normalizeClass(unref(dialogKls)),
        style: normalizeStyle(unref(style)),
        tabindex: "-1"
      }, [createElementVNode("header", {
        ref_key: "headerRef",
        ref: headerRef,
        class: normalizeClass(unref(ns).e("header"))
      }, [renderSlot(_ctx.$slots, "header", {}, () => [createElementVNode("span", {
        role: "heading",
        "aria-level": _ctx.ariaLevel,
        class: normalizeClass(unref(ns).e("title"))
      }, toDisplayString(_ctx.title), 11, _hoisted_1)]), _ctx.showClose ? (openBlock(), createElementBlock("button", {
        key: 0,
        "aria-label": unref(t)("el.dialog.close"),
        class: normalizeClass(unref(ns).e("headerbtn")),
        type: "button",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit("close"))
      }, [createVNode(unref(ElIcon), {
        class: normalizeClass(unref(ns).e("close"))
      }, {
        default: withCtx(() => [(openBlock(), createBlock(resolveDynamicComponent(_ctx.closeIcon || unref(Close))))]),
        _: 1
      }, 8, ["class"])], 10, _hoisted_2)) : createCommentVNode("v-if", true)], 2), createElementVNode("div", {
        id: unref(bodyId),
        class: normalizeClass(unref(ns).e("body"))
      }, [renderSlot(_ctx.$slots, "default")], 10, _hoisted_3), _ctx.$slots.footer ? (openBlock(), createElementBlock("footer", {
        key: 0,
        class: normalizeClass(unref(ns).e("footer"))
      }, [renderSlot(_ctx.$slots, "footer")], 2)) : createCommentVNode("v-if", true)], 6);
    };
  }
}));
var ElDialogContent = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "dialog-content.vue"]]);
export { ElDialogContent as default };